import {
	AlertDialog,
	AlertDialogBody,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Button,
} from "@chakra-ui/react";
import React, { useRef } from "react";
import { COLORS } from "../../../../Helper/Colors";
import DotSpinner from "../../DotSpinner";

export const DeleteModal = ({
	isOpen,
	onCancel,
	onDelete,
	heading,
	title,
	deleteBtnLoading,
}) => {
	const cancelRef = useRef();
	return (
		<AlertDialog
			isOpen={isOpen}
			leastDestructiveRef={cancelRef}
			onClose={onCancel}
			isCentered
		>
			<AlertDialogOverlay textAlign={"start"}>
				<AlertDialogContent>
					<AlertDialogHeader fontSize="lg" fontWeight="bold">
						{heading || "Delete"}
					</AlertDialogHeader>

					<AlertDialogBody>
						{title || "Are you sure? You can't undo this action afterwards."}
					</AlertDialogBody>

					<AlertDialogFooter display={"flex"} justifyContent="end">
						<Button
							colorScheme="brand"
							onClick={onDelete}
							backgroundColor={COLORS.brand}
							spinner={
								<DotSpinner
									key={"campaign-manager-delete"}
									color={COLORS.light}
									size={8}
								/>
							}
							isLoading={deleteBtnLoading}
						>
							Delete
						</Button>
						<Button
							ml={3}
							variant="outline"
							colorScheme={"brand"}
							ref={cancelRef}
							onClick={onCancel}
						>
							Cancel
						</Button>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialogOverlay>
		</AlertDialog>
	);
};
